import { createSlice } from "@reduxjs/toolkit";

const GalleryAndNewsSlice = createSlice({
  name: "GalleryAndNews",
  initialState: {
    News: {
      data: [],
      loading: false,
      error: null,
    },

    studentPortal: {
      data: [],
      loading: false,
      error: null,
    },
    office: {
      data: [],
      loading: false,
      error: null,
    },
    onlinePayment: {
      data: [],
      loading: false,
      error: null,
    },

    passwordManager: {
      data: [],
      loading: false,
      error: null,
    },

    helpDesk: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: { 
    addNewsStart(state) {
        state.News.loading = true;
        state.News.error = null;
    },
    addNewsSuccess(state, action) {
        state.News.loading = false;
        state.News.data = action.payload;
    },
    addNewsFailure(state, action) {
        state.News.loading = false;
        state.News.error = action.payload;
    },
    fetchNewsStart(state) {
      state.News.loading = true;
      state.News.error = null;
    },
    fetchNewsSuccess(state, action) {
      state.News.loading = false;
      state.News.data = action.payload;
    },
    fetchNewsFailure(state, action) {
      state.News.loading = false;
      state.News.error = action.payload;
    },
    updateNewsStart(state) {
      state.News.loading = true;
      state.News.error = null;
    },
    updateNewsSuccess(state, action) {
      state.News.loading = false;
      state.News.data = action.payload;
    },
    updateNewsFailure(state, action) {
      state.News.loading = false;
      state.News.error = action.payload;
    },

    deleteNewsStart(state) {
      state.News.loading = true;
      state.News.error = null;
    },
    deleteNewsSuccess(state, action) {
      state.News.loading = false;
      state.News.data = action.payload;
    },
    deleteNewsFailure(state, action) {
      state.News.loading = false;
      state.News.error = action.payload;
    },   
  },
});
export const {
  addNewsStart,
  addNewsSuccess,
  addNewsFailure,
  fetchNewsStart,
  fetchNewsSuccess,
  fetchNewsFailure,
  updateNewsStart,
  updateNewsSuccess,
  updateNewsFailure,
  deleteNewsStart,
  deleteNewsSuccess,
  deleteNewsFailure
}= GalleryAndNewsSlice.actions;

export default GalleryAndNewsSlice.reducer;
